import { isDuplicateNameInNavigations } from "../PageBuilder/createpages/dragUtils";

export const SECTOR_COUNTRY_MAPPING = "Sector country mapping";

export const DISCLAIMER = "Disclaimer";

export const validatePageGroupName = (
  name,
  navigations,
  excludeId = null,
  setValidationError
) => {
  if (!name || !name.trim()) {
    setValidationError("");
    return;
  }
  
  const isDuplicate = isDuplicateNameInNavigations(name, navigations, excludeId);
  
  if (isDuplicate) {
    setValidationError("This name already exists. Please choose a different name.");
  } else {
    setValidationError("");
  }
};
